import {
    NATIONAL_HAUL_RATES_REQUEST,
    NATIONAL_HAUL_RATES_SUCCESS,
    NATIONAL_HAUL_RATES_FAILURE
} from '../../actions/truckLoadRate/nationalActions';

interface NationalCharts {
    isFetchingNationalHaulRates: boolean;
    nationalHaulRates: any;
}

const fetchNationalChartsReducer = (dataChartsNationalCharts: NationalCharts = {
    isFetchingNationalHaulRates: false,
    nationalHaulRates: {}
}, action: any): NationalCharts => {
    switch (action.type) {
        case NATIONAL_HAUL_RATES_REQUEST: {
            return {
                ...dataChartsNationalCharts,
                isFetchingNationalHaulRates: true
            };
        }
        case NATIONAL_HAUL_RATES_SUCCESS: {
            return {
                ...dataChartsNationalCharts,
                isFetchingNationalHaulRates: false,
                nationalHaulRates: action.payload
            };
        }
        case NATIONAL_HAUL_RATES_FAILURE: {
            return {
                ...dataChartsNationalCharts,
                isFetchingNationalHaulRates: false,
                nationalHaulRates: {}
            };
        }
        default:
            return dataChartsNationalCharts;
    }
};

export default fetchNationalChartsReducer;
